export default function KnowledgeBase() {
  window.location.replace(
    "https://boreas-portal-knowledge-base-files.s3.us-west-2.amazonaws.com/boreas_knowledge_base_5_30_25.pdf"
  );
}
